module.exports = __webpack_public_path__ + "static/media/Badge_SvgFormationCoin_Gold.b6ccb3cf.svg";